module.exports = __webpack_public_path__ + "media/images/podio-f49a700acc77c877c6b24265710e39ab.png";